import {Component, CUSTOM_ELEMENTS_SCHEMA, viewChild} from '@angular/core';
//import {DataGrid} from '@fluentui/web-components';
import {WjFlexSheet, WjGridSheetModule} from '@mescius/wijmo.angular2.grid.sheet';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjGridSheetModule
    ],
    template: `
        <div class="fullsize-vbox" style="gap: 5px;">
            <div class="toolbar-horizontal">
                <fluent-button>Hi</fluent-button>
            </div>
            <wj-flex-sheet #flex (initialized)="initializeFlexSheet(flex)">
                <wj-sheet [name]="'unbound'" ></wj-sheet>
            </wj-flex-sheet>
        </div>
    `,
    styles: `
        wj-flex-sheet {
            flex: 1;
            width: 100%;
        }
    `
})
export class TestWijmoSheetComponent {

    // private readonly grid = viewChild.required<DataGrid>('grid');

    constructor() {
    }

    initializeFlexSheet(flex: WjFlexSheet) {

    }
}
